<nav id="menu-support" (keyup.escape)="close()" aria-label="Support Menu">
    <div id="support-header">
        <deco-icon [iconClass]="'fa-regular fa-comment-question'" [color]="'#fff'" [fontSize]="'18px'" />
        <p>{{ 'toolbar.supportPanel.header' | translate }}</p>
    </div>

    <a
        id="support-hub-link"
        tabindex="0"
        aria-label="Go to Support Hub"
        (click)="goToSupportHub(); logAction('support-hub')"
        (keyup.enter)="goToSupportHub(); logAction('support-hub')">
        <div class="item-container">
            <div class="btn-icon" id="support-hub-icon">
                <deco-icon [iconClass]="'fa-light fa-circle-question'" [color]="'#000'" />
            </div>
            <label for="support-hub-icon" id="support-hub-label">{{ 'supportMenu.supportHub' | translate }}</label>
        </div>
        <deco-icon [iconClass]="'fa-regular fa-arrow-up-right-from-square'"></deco-icon>
    </a>
    <a
        id="phone"
        tabindex="0"
        aria-label="Call 1-888-321-2113"
        (click)="callPhone(); logAction('phone')"
        (keyup.enter)="callPhone(); logAction('phone')">
        <div class="item-container">
            <div class="btn-icon" id="phone-icon">
                <deco-icon [iconClass]="'fa-light fa-phone'" [color]="'#000'" />
            </div>
            <label for="phone-icon" id="phone-label">1-888-321-2113</label>
        </div>
    </a>
    <a
        id="email"
        tabindex="0"
        aria-label="Mail to Transnetyx"
        (click)="openEmail(); logAction('mail')"
        (keyup.enter)="openEmail(); logAction('mail')">
        <div class="item-container">
            <div class="btn-icon" id="email-icon">
                <deco-icon [iconClass]="'fa-light fa-envelope'" [color]="'#000'" />
            </div>
            <label for="email-icon" id="email-label">{{ 'Help@transnetyx.com' }}</label>
        </div>
    </a>
    <a
        id="chat"
        class="hf-chat"
        tabindex="0"
        aria-label="Open Chat"
        (click)="openChat(); logAction('chat')"
        (keyup.enter)="openChat(); logAction('chat')">
        <div class="item-container">
            <div class="btn-icon" id="chat-icon">
                <deco-icon [iconClass]="'fa-light fa-comments'" [color]="'#000'" />
            </div>
            <label for="chat-icon" id="chat-label">{{ 'supportMenu.liveChat' | translate }}</label>
        </div>
    </a>
    <a
        id="terms-of-use-link"
        tabindex="0"
        aria-label="Open Terms of use"
        (click)="goToTermsOfUse(); logAction('terms-of-use')"
        (keyup.enter)="goToTermsOfUse(); logAction('terms-of-use')">
        <div class="item-container">
            <div class="btn-icon" id="terms-of-use-icon">
                <deco-icon [iconClass]="'fa-light fa-file-contract'" [color]="'#000'" />
            </div>
            <label for="terms-of-use-icon" id="terms-of-use-label">{{ 'supportMenu.termsOfUse' | translate }}</label>
        </div>
        <deco-icon [iconClass]="'fa-regular fa-arrow-up-right-from-square'"></deco-icon>
    </a>
</nav>
